// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"pO","cardInnerHeading":"pP","editButton":"pQ","formClass":"pR","inputClass":"pS","pw":"pT","enterCurrentPw":"pU","cancelButton":"pV","submitButton":"pW"};